import React from 'react'

import { ArticleHero } from 'component-library/publication/ArticleHero/ArticleHero'
import { ArticleBlockContent } from 'component-library/publication/ArticleBlockContent/ArticleBlockContent'
import { Headline } from 'component-library/publication/Headline/Headline'
import { Byline } from 'component-library/publication/Byline/Byline'
import { Footnote } from 'component-library/publication/Footnote/Footnote'

import { TopicLabel } from 'component-library/typography/TopicLabel/TopicLabel'
import { TopicList } from 'component-library/content/TopicList/TopicList'
import { Sharing } from 'component-library/buttons/Sharing/Sharing'

import {
    StyledArticleContent,
    StyledGrid,
    StyledCell,
    StyledInsetCell,
} from 'component-library/templates/Publication/PerthNowPublication/PerthNowPublication.styled'

import { getCanonicalLink } from 'component-library/templates/Publication/lib/get-canonical-link'
import { PublicationProps } from 'component-library/templates/Publication/Publication.props'

export const PerthNowPublication: React.FC<PublicationProps> = props => {
    const publication = props.data
    const content = publication.content
    const canonicalLink = getCanonicalLink(publication)
    const heroImage = publication.heroImage
    const secondaryTopics = publication.secondaryTopics
    const targetedContentElement =
        props.targetedContent && props.targetedContent.position === 'inline'
            ? props.targetedContent.element
            : undefined

    return (
        <StyledGrid>
            <StyledCell>
                <ArticleHero
                    heroVideo={publication.heroVideo}
                    heroImage={heroImage}
                    heading={publication.heading}
                    onEvent={props.onEvent}
                    showVideoTitles={true}
                    autoplayNextOptionssOverrides={{ delayDuration: 5 }}
                    isVideoStickyEnabled={props.heroOptions.isVideoStickyEnabled}
                    getVideoQueue={props.getVideoQueue}
                    publicationPathname={props.location.pathname}
                    adUnitPath={props.adUnitPath}
                />
            </StyledCell>

            <StyledInsetCell>
                <TopicLabel {...props.sectionAssignment} />
            </StyledInsetCell>

            <StyledInsetCell>
                <Headline text={publication.heading} />
            </StyledInsetCell>

            <StyledInsetCell>
                <Byline
                    profile={publication.profile}
                    text={publication.byline}
                    isSponsored={publication.isSponsored}
                    timestamp={publication.publicationDate}
                    source={publication.source}
                    isLive={publication.isLive}
                    isFullWidth={true}
                    url={publication._self}
                    title={publication.heading}
                />
            </StyledInsetCell>

            {secondaryTopics.length > 0 && (
                <StyledInsetCell>
                    <TopicList secondaryTopics={publication.secondaryTopics} />
                </StyledInsetCell>
            )}

            <StyledCell>
                {content && (
                    <StyledArticleContent>
                        <ArticleBlockContent
                            blocks={content}
                            targetedContentElement={targetedContentElement}
                            inlinePositionedContent={props.inlinePositionedContent}
                            onEvent={props.onEvent}
                            log={props.log}
                            publicationPathname={props.location.pathname}
                            adUnitPath={props.adUnitPath}
                            getVideoQueue={props.getVideoQueue}
                        />
                    </StyledArticleContent>
                )}
            </StyledCell>

            <StyledInsetCell>
                {canonicalLink && <Footnote text="Originally published as " link={canonicalLink} />}
            </StyledInsetCell>
            <StyledInsetCell>
                <Sharing
                    url={publication._self}
                    text={publication.heading}
                    onEvent={props.onEvent}
                    shareOptions={['facebook', 'twitter', 'email', 'clipboard']}
                />
            </StyledInsetCell>
        </StyledGrid>
    )
}
